import React from 'react';
import _ from 'lodash';
import {formatMoney} from "accounting-js";
import {Control, Errors} from "react-redux-form";
import {isRequired} from "../../field_validations";
import DatePick from "../../forms/datepicker";
import TextEditor from "../../forms/wysiwyg_field";

const ProjectDataForm = (props) => {
	return <fieldset className="fieldset">
		<legend>Datos del proyecto</legend>

		{!_.isEmpty(props.revision) &&
		<div className="field">
			<div className="control">
				<p className={`tag is-${props.revision.status}`}>{props.revision.comment}</p>
			</div>
		</div>}

		<div className="field is-grouped is-grouped-right">
			<div className="control">
				<label htmlFor="amount" className="label">Monto total de las metas</label>
				{props.fetching ?
				<p className="has-text-right"><i className="fa fa-spin fa-lg fa-spinner"/></p> :
				<p className="title is-5 has-text-right">{!_.isEmpty(props.data) ? formatMoney(props.data.amounts) : '$ 0.00'}</p>}
			</div>
		</div>

		<div className="field">
			<div className={`control${props.fetching ? ' is-loading' : ''}`}>
				<label htmlFor="name" className="label">Nombre del proyecto <span
					className="small has-text-danger">*</span></label>
				<Control.text
					model=".name"
					id="name"
					className={`input${!props.fetching && !_.isEmpty(props.revision) ? ' is-' + props.revision.status : ''}`}
					value={props.data && props.data.name ? props.data.name : ''}
					placeholder="Nombre del Proyecto"
					errors={{isRequired}}
					validateOn="change"
					disabled={props.disabled}/>
				<Errors
					model=".name"
					show="touched"
					wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
					messages={{isRequired: 'El nombre del proyecto es obligatorio'}}/>
			</div>
		</div>

		<div className="field is-grouped">
			<div className="control is-expanded">
				<label htmlFor="version_id" className="label">Año</label>
				<p>{!_.isEmpty(props.data) && props.data.agency && props.data.agency.version ? props.data.agency.version.year : '---'}</p>
			</div>

			<div className={`control is-expanded${props.fetching ? ' is-loading' : ''}`}>
				<label htmlFor="execution_start" className="label">Fecha de ejecución inicial <span
					className="small has-text-danger">*</span></label>
				<Control.text
					model=".execution_start"
					id="execution_start"
					value={props.data && props.data.execution_start ? props.data.execution_start : ''}
					errors={{isRequired}}
					validateOn="change"
					component={DatePick}
					className={`input${!props.fetching && !_.isEmpty(props.revision) ? ' is-' + props.revision.status : ''}`}
					disabled={props.disabled}/>
				<Errors
					model=".execution_start"
					show="touched"
					wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
					messages={{isRequired: 'La fecha es obligatoria'}}/>
			</div>

			<div className={`control is-expanded${props.fetching ? ' is-loading' : ''}`}>
				<label htmlFor="execution_end" className="label">Fecha de ejecución final <span
					className="small has-text-danger">*</span></label>
				<Control.text
					model=".execution_end"
					value={props.data && props.data.execution_end ? props.data.execution_end : ''}
					errors={{isRequired}}
					validateOn="change"
					id="execution_end"
					component={DatePick}
					className={`input${!props.fetching && !_.isEmpty(props.revision) ? ' is-' + props.revision.status : ''}`}
					disabled={props.disabled}/>
				<Errors
					model=".execution_end"
					show="touched" wrapper={(props) => <small
					className="help has-text-danger">{props.children}</small>}
					messages={{isRequired: 'La fecha es obligatoria'}}/>
			</div>
		</div>

		<div className="field is-grouped">
			{(!_.isEmpty(props.data) && props.data.code) &&
				<div className={`control is-expanded${props.fetching ? ' is-loading' : ''}`}>
					<label htmlFor="code" className="label">Código</label>
					<Control.text
						model=".code" type="number"
						className={`input${(!props.fetching && !_.isEmpty(props.revision)) ? ' is-' + props.revision.status : ''}`}
						placeholder="000"
						disabled
					/>
				</div>}

			<div className={`control is-expanded${props.fetching ? ' is-loading' : ''}`}>
				<label className="label">Entidad</label>
				<p>{props.data && props.data.agency ? props.data.agency.agenciable.name : '---'}</p>
			</div>

			<div className={`control is-expanded${props.fetching ? ' is-loading' : ''}`}>
				<label className="label">Instancia</label>
				<p>{!_.isEmpty(props.data) && props.data.agency ? props.data.agency.name : '---'}</p>
			</div>
		</div>

		<div className="field">
			<div className={`control${props.fetching ? ' is-loading' : ''}`}>
				<label htmlFor="objective" className="label">Objetivos <span
					className="small has-text-danger">*</span></label>
				<Control.textarea
					model=".objective"
					component={TextEditor}
					className={(!props.fetching && !_.isEmpty(props.revision)) ? 'is-' + props.revision.status : ''}
					id="objective"
					placeholder="Objetivos del proyecto"
					errors={{isRequired}} validateOn="change"
					readOnly={props.disabled}
				/>
				<Errors
					model=".objective"
					show="touched"
					wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
					messages={{isRequired: 'Los objectivos del proyecto son obligatorios'}}
				/>
			</div>
		</div>

		<div className="field">
			<div className={`control is-expanded${props.fetching ? ' is-loading' : ''}`}>
				<label htmlFor="justification" className="label">
					Justificación
					<span className="small has-text-danger">*</span>
				</label>
				<Control.textarea
					model=".justification"
					component={TextEditor}
					className={!props.fetching && !_.isEmpty(props.revision) ? 'is-' + props.revision.status : ''}
					id="justification"
					placeholder="Justificación del proyecto"
					errors={{isRequired}}
					validateOn="change"
					readOnly={props.disabled}
				/>
				<Errors
					model=".justification"
					show="touched"
					wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
					messages={{isRequired: 'La justificación del proyecto es obligatorio'}}
				/>
			</div>
		</div>
	</fieldset>
}

export default ProjectDataForm;


// WEBPACK FOOTER //
// ./src/elements/project/widgets/project_data_form.jsx